import { defaultConfig, defineSlotRecipe } from '@chakra-ui/react';

import merge from 'lodash/merge';

export const segmentGroupRecipe = defineSlotRecipe(
    merge(defaultConfig?.theme?.slotRecipes?.segmentGroup, {
        variants: {
            variant: {
                separated: {
                    root: {
                        boxShadow: 'none',
                        bg: 'transparent',
                        gap: 2,
                    },
                    item: {
                        '--segment-radius': '{radii.full}',
                        px: 3,
                        cursor: 'pointer',
                        color: 'gray.900',
                        bg: 'white',
                        border: '1px solid',
                        borderColor: 'gray.400',
                        _checked: {
                            color: 'secondary.600',
                            bg: 'secondary.50',
                            borderColor: 'secondary.600',
                            fontWeight: 'bold',
                        },
                        _horizontal: {
                            _before: {
                                display: 'none',
                            },
                        },
                    },
                    itemText: {
                        fontSize: 'xs',
                    },
                    indicator: {
                        boxShadow: 'none',
                    },
                },
            },
        },
    }),
);
